<template>
    <div class="char-countdown" v-if="field">
        <div class="max">{{ $t__('Max %d chars.', 255) }}</div>
        <div class="remaining"><span :class="counterClass">{{ remainingCount }}</span> {{ $c__('count of characters', 'remaining') }}</div>
    </div>
</template>

<script>
    export default {
        name: 'CharCountdown',

        props: {
            fieldRef: {
                type: String,
                required: true
            }
        },

        data: () => ({
            field: null,
            maxCount: 0,
            fieldContentCount: 0,
            remainingCount: 0,
            counterClass: 'color-positive-darker'
        }),

        mounted() {
            this.field = this.$root.$refs[this.fieldRef] || this.$parent.$parent.$refs[this.fieldRef];

            if (!this.field) return;

            this.maxCount = this.field.getAttribute('maxlength');

            this.fieldContentCount = this.field.value.length;
            this.countdown();

            this.field.addEventListener('input', this.onInput, false);
        },

        methods: {
            onInput() {
                this.fieldContentCount = this.field.value.length;
                this.countdown();
            },

            countdown() {
                this.remainingCount = this.maxCount - this.fieldContentCount;

                if (this.remainingCount < this.maxCount/4) {
                    this.counterClass = 'color-negative-darker';
                } else if(this.remainingCount < this.maxCount/3) {
                    this.counterClass = 'color-attention-darker';
                } else {
                    this.counterClass = 'color-positive-darker';
                }
            }
        }
    }
</script>
